import { Injectable } from '@angular/core';

import { PackType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PackTypeService extends TmsWebBaseEditService<PackType, PackType> {
  constructor() {
    super('PackType', $localize`Pack Type`);
  }
}
